import React, { useContext } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import axios from 'axios'
import { ENDPOINT } from '../../ImportBackend/Config/emDesenvolvimento'
import { useNavigate } from 'react-router-dom'

export default function ImportarRelat () {

  const { setMensagemState } = ( useContext( ContextoGlobal ) as ContextoGlobalInterface )
  const navigate = useNavigate()

  const getToken = () => {
    const token = localStorage.getItem( 'token' )
    return token ? token : ''
  }

  const btUpload = () => {


    let input: HTMLInputElement = document.createElement( 'input' )

    input.type = 'file'
    input.name = 'nomeArquivo'
    input.accept = '.dbf'

    input.onchange = () => {

      if ( input.files ) {

        const formulario: FormData = new FormData()

        formulario.append( 'nomeArquivo', input.files[0] )
        formulario.append( 'token', getToken() )

        setMensagemState( {
          mensagem: 'Carregando Arquivo...',
          exibir: true,
          exibirBotao: false,
          titulo: 'Aguarde!',
          tipo: 'Loading',
          cb: null
        } )

        axios.post( ENDPOINT.concat( 'uploadRelat' ), formulario, {
          headers: {
            'content-type': 'multipart/form-data'
          } //,
          // onUploadProgress: this.calculaprogressoUpload
        } ).then( rs => {

          if ( !rs.data.ok ) {

            setMensagemState( {
              mensagem: rs.data.mensagem,
              exibir: true,
              exibirBotao: true,
              titulo: 'Erro!',
              tipo: 'error',
              cb: null
            } )

          } else {

            setMensagemState( {
              mensagem: 'Dados Enviados com Sucesso!',
              exibir: true,
              exibirBotao: true,
              titulo: 'Sucesso!',
              tipo: 'success',
              cb: null
            } )

            navigate( '/' )

          }

        } ).catch( () => {
          setMensagemState( {
            mensagem: 'Erro no Servidor!',
            exibir: true,
            exibirBotao: true,
            titulo: 'Consulte Suporte!',
            tipo: 'error',
            cb: null
          } )
        } )

      }


    }

    input.click()

  }

  return (
    <>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        height='100vh'
      >
        <Grid item xs={10} sm={8} md={6} lg={4}>
          <Paper>
            <Box
              sx={{ backgroundColor: 'primary.main', padding: 2 }}
              textAlign='center'
            >
              <img src={process.env.REACT_APP_PASTA?.concat( "/logoFundoBranco.png" )} width={300} alt={process.env.REACT_APP_TITULO} />
            </Box>
            <Box sx={{ backgroundColor: 'white', padding: 2, mx: 5 }}            >
              <Grid>
                <Grid item textAlign='center'>
                  <Typography variant="h4" fontFamily='sans-serif' fontWeight='bolder' color="primary.main">
                    Upload do Arquivo Relat
                  </Typography>
                </Grid>

                <Grid item textAlign='right'>
                  <Button variant='contained' onClick={() => btUpload()} sx={{ mt: 5 }}>Enviar Arquivo</Button>
                </Grid>

              </Grid>

            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  )

}